/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SiteDto,
    SiteDtoFromJSON,
    SiteDtoFromJSONTyped,
    SiteDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PositionDto
 */
export interface PositionDto {
    /**
     * 
     * @type {number}
     * @memberof PositionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionDto
     */
    positionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionDto
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<SiteDto>}
     * @memberof PositionDto
     */
    sites?: Array<SiteDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PositionDto
     */
    isActive?: boolean;
}

export function PositionDtoFromJSON(json: any): PositionDto {
    return PositionDtoFromJSONTyped(json, false);
}

export function PositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'positionCode': !exists(json, 'positionCode') ? undefined : json['positionCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'sites': !exists(json, 'sites') ? undefined : (json['sites'] === null ? null : (json['sites'] as Array<any>).map(SiteDtoFromJSON)),
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function PositionDtoToJSON(value?: PositionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'positionCode': value.positionCode,
        'name': value.name,
        'comment': value.comment,
        'sites': value.sites === undefined ? undefined : (value.sites === null ? null : (value.sites as Array<any>).map(SiteDtoToJSON)),
        'isActive': value.isActive,
    };
}


